module.exports = __webpack_public_path__ + "fonts/Gibson-Regular.6e0ca3cb.woff2";